import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes, { checkPropTypes } from 'prop-types';
import { NotificationList, NotificationHeading } from './notificationStyles';
import NotificationCard from './NotificationCard';

const NotificationCategoryByTime = (props) => {
  const {
    data = defaultProps.data,
    headerText = defaultProps.headerText,
    notificationReadStatusHandler = defaultProps.notificationReadStatusHandler,
    closeDrawer = defaultProps.closeDrawer
  } = props;
  checkPropTypes(
    NotificationCategoryByTime.propTypes,
    props,
    'prop',
    NotificationCategoryByTime.name
  );
  const { t } = useTranslation(['TRANSLATIONS_RCORE_TOPNAV']);
  const updateNotification = (notificationId) =>
    notificationReadStatusHandler(notificationId, headerText);
  return (
    <>
      <NotificationHeading>{t(headerText)}</NotificationHeading>
      <NotificationList>
        {data.map((type) => (
          <NotificationCard
            key={type.notificationId}
            notificationData={type}
            updateNotification={updateNotification}
            closeDrawer={closeDrawer}
          />
        ))}
      </NotificationList>
    </>
  );
};

// PropType check
NotificationCategoryByTime.propTypes = {
  /**
   * Notification Data
   */
  data: PropTypes.arrayOf(PropTypes.shape({})),
  /**
   * header translation text
   */
  headerText: PropTypes.string,
  /**
   * Notification read status change callback
   */
  notificationReadStatusHandler: PropTypes.func,
  /**
   * Callback to close the drawer
   */
  closeDrawer: PropTypes.func
};

const defaultProps = {
  data: {},
  headerText: '',
  notificationReadStatusHandler: undefined,
  closeDrawer: undefined
};

export default NotificationCategoryByTime;
